import React, { Component } from 'react';
import { Provider } from 'react-redux'
import { createStore } from 'redux'
import rootReducer from './components/store/reducers'
import { BrowserRouter as Router, Route } from "react-router-dom";

import SocketAPI from './services/socketAPI';

import Home from './components/pages/Home/Home';
import Login from "./components/pages/Login/Login";
import Quiz from "./components/pages/Quiz/Quiz";
import EndQuiz from './components/pages/EndQuiz/EndQuiz';


import './styles/App.css';

// TODO: move store to separate file!

export const store = createStore(
	rootReducer,
	window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

class App extends Component {

	constructor(props) {
		super(props);
		SocketAPI.init();
	}

	render() {
		let body = 
			<Provider store={store}>
				<Router>
					<div>
						<Route exact path="/" component={Home} />
						<Route path="/login" component={Login} />
						<Route path="/quiz" component={Quiz} />
						<Route path="/result" component={EndQuiz} />
					</div>
				</Router>
			</Provider>
		return (
			<div className="AppDevice">
				{body}
			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js